import { Box, Button, Image, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet-async"
import { Link } from "react-router-dom"

const GenericNotFound = ({ staticContext = {} }) => {
  staticContext.status = 404

  return (
    <>
      <Helmet>
        <meta content="noindex" name="robots" />
      </Helmet>
      <Box contain py={8} textAlign="center">
        <Image
          alt="404 Page Not Found"
          mb={2}
          ratio="1024 / 900"
          src={`${sl.config.jewlr_asset_url}images/icons/jewlr/404.svg`}
          width="400"
        />
        <Typography mb={3} variant="body3">
          We&apos;re sorry, the page that you are looking for cannot be found.
        </Typography>
        <Button
          as={Link}
          data-lc="not-found"
          fontSize={14}
          letterSpacing="normal"
          mb={2}
          outline="black"
          px={3}
          py={1}
          radius="0"
          to="/"
        >
          CONTINUE SHOPPING
        </Button>
      </Box>
    </>
  )
}

GenericNotFound.propTypes = {
  staticContext: PropTypes.object,
}

export default GenericNotFound
